import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
//import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import * as type from "./actionTypes";
import * as PlansAction from "./actions";
import { PlansService } from "./service";

@Injectable()
export class PlansEffect {
  constructor(
    private action: Actions,
    private PlansService: PlansService
  ) {}

  GetPlansList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_PLANS_LIST),
      switchMap((data: any) => this.PlansService.getPlansList()),
      map((data: Array<any>) => new PlansAction.SetPlansList(data))
    )
  );

  GetModulesAndFeatures = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_MODULES_AND_FEATURES_LIST),
      switchMap((data: any) => this.PlansService.modulesAndFeaturesList()),
      map((data: Array<any>) => new PlansAction.SetModulesAndFeatures(data))
    )
  );

  PlansById = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_PLANS_BY_ID),
      switchMap((data: any) => this.PlansService.getPlansById(data.payload)),
      map((data: any) => new PlansAction.SetPlansById(data))
    )
  );

  GetPlanTemplateById = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_PLAN_TEMPLATE_BY_ID),
      switchMap((data: any) => this.PlansService.getPlanTemplateById(data.payload)),
      map((data: any) => new PlansAction.SetPlanTemplateById(data))
    )
  );

  AddPlans = createEffect(() =>
    this.action.pipe(
      ofType(type.ADD_PLANS),
      switchMap((data: any) => this.PlansService.addPlans(data.payload)),
      map((data: any) => new PlansAction.AddPlansResponse(data))
    )
  );

  UpdatePlans = createEffect(() =>
    this.action.pipe(
      ofType(type.UPDATE_PLANS),
      switchMap((data: any) => this.PlansService.updatePlans(data.payload)),
      map((data: any) => new PlansAction.UpdatePlansResponse(data))
    )
  );

  DeletePlans = createEffect(() =>
    this.action.pipe(
      ofType(type.DELETE_PLANS),
      switchMap((data: any) => this.PlansService.deletePlans(data.payload)),
      map((data: any) => new PlansAction.DeletePlansResponse(data))
    )
  );
}
